<template>
    <div class="screen-monitor-container">
        <div style="width: 100%;height: 100%;">
            <template v-for="(item, index) in layout.components">
                <div :id="item.name" :class="`screen-chart-container ${item.name}`"
                     :key="item.name" draggable='true'>
                    <component :class="`animated ${index < layout.leftSideNum ? 'bounceInLeft' : 'bounceInRight'}`"
                               :is="item.render" @openDialog="openDialog"
                               v-on="$listeners" :ref="item.render"/>
                </div>
            </template>
        </div>

      <div class="dialog" v-if="show">
        <div class="close" @click="closeDialog">
          <img src="@/assets/img/close_dialog.png" alt="" />
        </div>
        <div class="dialog-inner">
          <div class="dialog-title">高危!PHP CGIWindows平台远程代码执行漏洞CGIWindows平台远程代码执行漏洞ws平台远程代码执行漏洞</div>

          <div class="list-data">
            <div class="list-data-title">
              <td>漏洞编号</td>
              <td>类型</td>
              <td>等级</td>
              <td>受影响版本</td>
              <div class="list-data-title-bor"></div>
              <div class="list-data-title-bor-sed"></div>
              <div class="list-data-title-bor-th"></div>
            </div>

            <div class="data-list-container">
              <div class="data-list-column" v-for="item in bugList">
                <td class="td-column">{{item.value1}}</td>
                <td class="td-column">{{item.value2}}</td>
                <td class="td-column">{{item.value3}}</td>
                <td class="td-column">{{item.value4}}</td>
              </div>
            </div>

            <div class="list-data list-data-box">
              <div class="list-data-title list-data-content">
                <div class="list-data-content-txt">
                  数据来源 数据来源 数据来源 数据来源 数据来源 数据来源 数据来源
                  数据来源 数据来源 数据来源 数据来源 数据来源 数据来源 数据来源
                  数据来源 数据来源 数据来源 数据来源 数据来源 数据来源 数据来源
                  数据来源 数据来源 数据来源 数据来源 数据来源 数据来源 数据来源
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "dp-layout",
  props: {
    layout: Object
  },
  data() {
    return {
      show: false,
      drag: true,
      draggableArray: [],
      bugList: [
        {value1: "CVE-2024-4577", value2: "远程代码执行漏洞", value3: "高危", value4: "PHP@(8.3,8.3.8)PHP@(8.3,8.3.8)"}
      ]
    };
  },
  methods: {
    openDialog() {
      this.show = true;
    },
    closeDialog() {
      this.show = false;
    }
  }
};
</script>

<style scoped lang="less">
.screen-monitor-container {
    .screen-chart-container {
        position: absolute;

        /deep/ .echarts {
            width: 100%;
            height: 100%;
        }
    }
}

.dialog {
  position: relative;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(64, 67, 91, 0.3);
  padding-top: 100px;
  .close {
    position: absolute;
    z-index: 1000;
    left: 1250px;
    top: 125px;
    width: 17px;
    height: 17px;
    cursor: pointer;
    > img {
      width: 100%;
    }
  }
  .dialog-inner {
    width: 700px;
    height: 440px;
    background-color: rgba(0, 0, 0, 0.8);
    margin: 0 auto;
    .dialog-title {
      color: rgba(241, 237, 255, 1);
      font-family: 'YouSheBiaoTiHei';
      font-size: 24px;
      text-align: center;
      text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
      padding: 10px;
      width: 630px;
    }
  }
}
.list-data {
  .list-data-title {
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    height: 36px;
    line-height: 36px;
    width: 650px;
    margin: 0 auto;
    position: relative;
    top: 40px;
    font-size: 14px;
    color: white;
    text-align: center;
    border: 1px solid #7678ae;
  }
  .list-data-content {
    height: 100px;
    line-height: 20px;
    background: rgba(53, 58, 80, 0.7);
    .list-data-content-txt {
      margin: 10px;
      text-align: left;
    }
  }
}
.list-data-box {
  position: relative;
  margin: 0 auto;
  top: -20px;
}
.list-data-title::before,
.list-data-title::after {
  content: '';
  position: absolute;
  width: 6px; /* 正方形边长 */
  height: 4px;
  background-color: #aaadeb; /* 正方形颜色 */
}

/* 左上角和右上角 */
.list-data-title::before {
  top: -1px;
  left: -1px; /* 左上角位置 */
  box-shadow: 645px 0 0 0 #aaadeb; /* 用box-shadow制作右上角 */
}

/* 左下角和右下角 */
.list-data-title::after {
  bottom: -1px;
  left: -1px; /* 左下角位置 */
  box-shadow: 645px 0 0 0 #aaadeb;
}

.list-data-title-bor {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 160px;
}

.list-data-title-bor-sed {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 325px;
}
.list-data-title-bor-th {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 485px;
}
td {
  width: 175px;
  font-weight: bold;
}
.data-list-container {
  cursor: pointer;
  position: relative;
  height: 140px;
  top: 45px;
  width: 650px;
  margin: 0 0 0 24px;
  overflow-y: auto;
  box-sizing: content-box;
  scrollbar-width: thin;
  scrollbar-color: #757ebe transparent;
  .data-list-column {
    .td-column {
      position: relative;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #FFF;
      font-weight: bold;
      word-wrap: break-word;
      word-break: break-all;
    }

  }
}

.data-list-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.data-list-container::-webkit-scrollbar-thumb {
  background-color: #757ebe;
  border-radius: 4px;
}

.data-list-container::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
